import { getRootBasedUrl, getStaticBasedPath, jsonUtfStringify }  from '@resolve-js/core'
import clientImports from '$resolve.clientImports'
import clientChunk from '$resolve.clientChunk'
import clientEntry_instance from "/app/client/index.js"
const constructorBindFunction =
    (
      constructorFunction,
      compileTimeOptions,
      compileTimeImports,
      runTimeOptions,
      runTimeImports
    ) => constructorFunction(
      { ...compileTimeOptions, ...runTimeOptions },
      { ...compileTimeImports, ...runTimeImports }
    )
const idempotentFunction = value => value
const utils = { getRootBasedUrl, getStaticBasedPath, jsonUtfStringify }
const entryArgs = {
      clientImports,
      ...clientChunk,
      utils
    }
const clientEntry = clientEntry_instance
clientEntry(entryArgs)